import React, { useState } from 'react';
import { RyzenMark } from './RyzenLogo';
import { useAuth } from '../context/AuthContext';
import './WelcomeGuide.css';

// Shown once per user, the first time they land in the app. Tracked on the
// server (user.seenGuide) so it never reappears on any device. Next / Skip, fade.
const STEPS = [
  { title: 'Welcome to RyzenOS', body: 'Your whole business in one place: leads, clients, finance, projects and your team. Here is a quick tour.' },
  { title: 'Leads and Clients', body: 'Track every enquiry in your pipeline and convert won leads into clients in a click.' },
  { title: 'Finance and Invoices', body: 'Record income and expenses, and create GST invoices from Tools. Tax splits into CGST and SGST automatically.' },
  { title: 'Files', body: 'Keep invoices and important documents in your Files section, right inside the workspace.' },
  { title: 'Make it yours', body: 'Add your company details, logo and bank info in Settings so they appear on everything you send.' },
];

export default function WelcomeGuide() {
  const { user, markGuideSeen } = useAuth();
  const [i, setI] = useState(0);
  const [fade, setFade] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.seenGuide || dismissed) return null;

  const finish = () => { setDismissed(true); markGuideSeen(); };
  const goto = (n) => {
    setFade(false);
    setTimeout(() => { setI(n); setFade(true); }, 160);
  };
  const next = () => (i < STEPS.length - 1 ? goto(i + 1) : finish());

  const step = STEPS[i];

  return (
    <div className="wg-overlay">
      <div className="wg-card">
        <button className="wg-skip" onClick={finish}>Skip</button>
        <div className="wg-mark"><RyzenMark size={30} /></div>
        <div className={`wg-body${fade ? ' wg-in' : ''}`}>
          <div className="wg-title">{step.title}</div>
          <div className="wg-text">{step.body}</div>
        </div>
        <div className="wg-dots">
          {STEPS.map((_, n) => <span key={n} className={`wg-dot${n === i ? ' on' : ''}`} onClick={() => goto(n)} />)}
        </div>
        <button className="wg-next" onClick={next}>{i < STEPS.length - 1 ? 'Next' : 'Get started'}</button>
      </div>
    </div>
  );
}
